<div class="label flex-row g-space-xs align-center justify-end">
  {{ 'communication.message.system.cases.criticity-changed' | translate }}
  <cam-criticity [criticity]="Number(this.case().OldCriticity)"></cam-criticity>
  {{ 'communication.message.system.cases.move-to' | translate }}
  <cam-criticity [criticity]="Number(this.case().NewCriticity)"></cam-criticity>
</div>
